<section>
    <div class="container-fluid">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">Home</li>
            <li class="breadcrumb-item">Reports</li>
            <li class="breadcrumb-item active">User Activity Log</li>
        </ol>
    </div>
</section>
<section>
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-12 p-0">
                <div class="card Title-bar-blue">
                    <div class="devcare-card-header">
                        <span class="devcare-sub-header Title-bar-text"><img src="../../../../assets/img/report.png"> User Activity Log</span>
                        <div class="float-right">
                            <button pButton (click)="clear(dt2)" label="Clear" class="p-button-raised" icon="pi pi-trash" 
                            style="height: 30px;background-color: aliceblue;color: #1a90d0;"></button>
                        </div>                       
                        &nbsp;&nbsp;
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<section>
    <div class="card">  
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="p-fluid p-formgrid p-grid">
                       <!-- <div class="p-field p-col-12 p-md-3"> -->
                        <div style="margin-left: auto; margin-right: auto; width: 25%;">
                            <label for="logPeriodId">Log Period<span class="required-field">*</span></label>
                            <p-dropdown [options]="userActivityLogGlobalFilterList" placeholder="Select a log period"
                            (onChange)="getUserActivityLogGlobalFilterOnChange($event)" [(ngModel)]="selectedLogPeriodId"
                            [ngModelOptions]="{standalone: true}" defaultLabel="Select"
                            optionLabel="description"></p-dropdown>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
          <div class="text-center">
            <button class="bg-success" pButton pRipple type="button" [disabled]="!this.isLogPeriodSelected" (click)="generateUserActivityLog(logPeriodId,dt2)" style="background-color: #1a90d0; color: white;font-weight: bold;"><img src="../../../../assets/img/New-rep.png" width="32px">Get Report</button>
            
          </div>
        </div>
        <br><br><br>
    </div>
    <br>
    <br>
</section>
<section>
    <div [hidden]="!showTable" class="card">
        <div class="card-header">
           <span class="text-lg font-weight-bold">User Activity Log</span>
           <div class="card-tools">
            <button pButton label="Clear" class="p-button-raised m-2" icon="pi pi-filter-slash"
            (click)="clearFilter(dt2)" style="float: left;height: 30px;"></button>
            <button pButton label="Export" class="p-button-raised  m-2" *ngIf="sharedService.checkPermission('Admin_Export')" (click)="exportUserActivityLogReport()"
            icon="pi pi-file-excel" type="button" style="height: 30px;"></button>
            <p-multiSelect [options]="allColumns" [(ngModel)]="selectedColumns" maxSelectedLabels="0" dropdownIcon="pi pi-list" selectedItemsLabel="{0} columns selected" optionLabel="header"  [showHeader] = "false">
                <ng-template let-column pTemplate="item">
                    <div class="column-item">
                        <div>{{column.header}}</div>
                    </div>
                </ng-template>
            </p-multiSelect>
            
        </div>
        </div>
        <div class="card-body" id="page-admin">
            <p-table id="vendorInvoice-report"  #dt2 [value]="userActivityLogList" [lazy]="true"
                (onLazyLoad)="loadUserActivityLogList($event)" paginatorDropdownAppendTo="body" dataKey="vendorCompanyName" [rows]="10"
                [showCurrentPageReport]="true" [resizableColumns]="true" columnResizeMode="expand"
                [rowsPerPageOptions]="[10,25,50,100,250,500,1000]" styleClass="p-datatable-gridlines"  [scrollable]="true" scrollHeight="350px"  [responsive]="true"
                [paginator]="isshowpaginator" [totalRecords]="totalRecords"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="colgroup" let-columns>
                    <colgroup [attr.colspan]="selectedColumns.length">
                        <col style="width: 3rem;">
                        <col style="width: 11rem" *ngIf="isShowColumns('fullName')">
                        <col style="width: 11rem" *ngIf="isShowColumns('companyName')">
                        <col style="width: 8rem" *ngIf="isShowColumns('accountType')">
                        <col style="width: 10rem" *ngIf="isShowColumns('primaryEmail')">
                        <col style="width: 12rem" *ngIf="isShowColumns('vendorCategory')">
                        <col style="width: 9rem" *ngIf="isShowColumns('primaryPhone')">
                        <col style="width: 8rem" *ngIf="isShowColumns('primaryPhoneExt')">
                        <col style="width: 10rem;" *ngIf="isShowColumns('userStatus')">
                        <col style="width: 11rem;" *ngIf="isShowColumns('lastLoginDate')">       
       
                    </colgroup>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="background-color: #1a90d0;color: rgb(255 255 255);width: 3rem;" pResizableColumn>#</th>
                        <th *ngIf="isShowColumns('fullName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>User 
                            <span pSortableColumn="fullName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="fullName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'fullName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()">
                            </app-basic-filter>
                            </th>
                        <th *ngIf="isShowColumns('companyName')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Company 
                            <span pSortableColumn="companyName" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="companyName" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'companyName'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('accountType')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8rem;" pResizableColumn>Role 
                            <span pSortableColumn="accountType" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="accountType" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'accountType'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('primaryEmail')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>Email 
                            <span pSortableColumn="primaryEmail" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="primaryEmail" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'primaryEmail'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('vendorCategory')"
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 12rem;" pResizableColumn>Vendor Category
                            <span pSortableColumn="vendorCategory" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="vendorCategory" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-dropdown-filter [field]="'vendorCategory'" [values]="allVendorCategories"
                                [optionLabel]="'description'" [optionValue]="'description'"[filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-dropdown-filter>
                            </th>
                            <th *ngIf="isShowColumns('primaryPhone')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 9rem;" pResizableColumn>Phone No. 
                            <span pSortableColumn="primaryPhone" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="primaryPhone" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'primaryPhone'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('primaryPhoneExt')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 8rem;" pResizableColumn>Ext. No. 
                            <span pSortableColumn="primaryPhoneExt" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="primaryPhoneExt" style="border-style:none !important"></p-sortIcon>
                            </span>
                                <app-basic-filter [field]="'primaryPhoneExt'" [filters]="filters" [table]="table"
                                (applyFilter)="applyFilterNew()"></app-basic-filter>
                            </th>
                            <th *ngIf="isShowColumns('userStatus')"
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 10rem;" pResizableColumn>User Status
                            <span  pSortableColumn="userStatus" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="userStatus" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-isactive-filter [field]="'userStatus'" [values]="userStatusValues"
                            [optionLabel]="'description'" [optionValue]="'id'"[filters]="filters" [table]="table"
                                        (applyFilter)="applyFilterNew()"></app-isactive-filter>
                        </th>
                        <th *ngIf="isShowColumns('lastLoginDate')" 
                            style="background-color: #1a90d0;color: rgb(255 255 255);width: 11rem;" pResizableColumn>Last Logged In
                            <span pSortableColumn="lastLoginDate" style="background-color: #1a90d0;color: rgb(255 255 255);">
                                <p-sortIcon field="lastLoginDate" style="border-style:none !important"></p-sortIcon>
                            </span>
                            <app-date-filter [field]="'lastLoginDate'" [filters]="filters" [table]="table"
                            (filterDate)="lastLoginDateFilterData($event)"
                            [filterData]="lastLoginDateFilterValue"></app-date-filter>
                        </th>
                    </tr>
                    <tr>
                        <th></th>
                        <th *ngIf="isShowColumns('fullName')">{{filters?.fullName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('companyName')">{{filters?.companyName[0]?.value}}</th>
                        <th *ngIf="isShowColumns('accountType')">{{filters?.accountType[0]?.value}}</th>
                        <th *ngIf="isShowColumns('primaryEmail')">{{filters?.primaryEmail[0]?.value}}</th>
                        <th *ngIf="isShowColumns('vendorCategory')">{{selectedVendorCategory}}</th>
                        <th *ngIf="isShowColumns('primaryPhone')">{{filters?.primaryPhone[0]?.value}}</th>
                        <th *ngIf="isShowColumns('primaryPhoneExt')">{{filters?.primaryPhoneExt[0]?.value}}</th>
                        <th *ngIf="isShowColumns('userStatus')">{{selectedUserStatus}}</th>
                            <th *ngIf="isShowColumns('lastLoginDate')">
                                <div *ngIf="lastLoginDateFilterValue != undefined">
                                    {{lastLoginDateFilterValue[0]?.valueControl| date:'MM/dd/yyyy'}} <span *ngIf="lastLoginDateFilterValue.length > 1">-</span> {{lastLoginDateFilterValue[1]?.valueControl | date:'MM/dd/yyyy'}}
                                </div>
                            </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userActivityLogList let-rowIndex="rowIndex">
                    <tr>
                        <td style = "width: 3rem">{{rowIndex + 1}}</td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('fullName')">{{userActivityLogList.fullName}}</td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('companyName')">{{userActivityLogList.companyName}}</td>
                        <td style = "width: 8rem" *ngIf="isShowColumns('accountType')">{{userActivityLogList.accountType}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('primaryEmail')">{{userActivityLogList.primaryEmail}}</td>
                        <td style = "width: 12rem" *ngIf="isShowColumns('vendorCategory')">
                            <span 
                            *ngIf="(userActivityLogList.vendorCategory==='DevCare - Requisition and Invoice')">Requisition and Invoice</span>
                            <span 
                            *ngIf="(userActivityLogList.vendorCategory==='DevCare - Subcontractor Invoice only')">Invoice Only</span>
                        </td>
                        <td style = "width: 9rem" *ngIf="isShowColumns('primaryPhone')">{{userActivityLogList.primaryPhone}}</td>
                        <td style = "width: 8rem" *ngIf="isShowColumns('primaryPhoneExt')">{{userActivityLogList.primaryPhoneExt}}</td>
                        <td style = "width: 10rem" *ngIf="isShowColumns('userStatus')">
                            <span class="customer-badge status-active"
                            *ngIf="(userActivityLogList.userStatus===true)">Active</span>
                            <span class="customer-badge status-inactive"
                            *ngIf="(userActivityLogList.userStatus===false)">Inactive</span>
                        </td>
                        <td style = "width: 11rem" *ngIf="isShowColumns('lastLoginDate')">{{userActivityLogList.lastLoginDate | date:'MM/dd/yyyy'}}</td>           
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                      <td [attr.colspan]="selectedColumns.length">No user activity log found.</td>
                    </tr>
                  </ng-template>
            </p-table>
        </div>      
    </div>
    <!-- <br><br><br><br> -->
</section>